
import { EmployeeDto } from "@/types/user.type";
import { Component, Prop, Mixins } from "vue-property-decorator";

import AuthMixin from "@/common/mixins/auth.mixin";

@Component
export default class EmployeeCardComponent extends Mixins(AuthMixin) {
  @Prop() employee!: EmployeeDto;
  @Prop({default: false}) showRating!: boolean;

  showDetails(employeeId: number): void {
    this.$emit("details", employeeId);
  }

  positionDescription(positions: string[]): string {
    if (!positions || positions.length == 0)
    return "";
    return positions.length == 1 
      ? positions[0]
      : `${positions[0]}, +${positions.length-1}`
  }

  positionTitle(positions: string[]): string {
    if (!positions || positions.length == 0)
      return "";
    return positions.join(", ");
  }
}
